export default __webpack_public_path__ + "static/sezgi-ulucam-d682a28e9ee9d82b1296ffc371c5cd0d.png";